"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SealockedHolmes = void 0;
var GlobalEventName_1 = require("../GlobalEventName");
var PartyName_1 = require("../../parties/PartyName");
var ResourceType_1 = require("../../../ResourceType");
var AddResourcesToCard_1 = require("../../../deferredActions/AddResourcesToCard");
var SealockedHolmes = (function () {
    function SealockedHolmes() {
        this.name = GlobalEventName_1.GlobalEventName.SEALOCKED_HOLMES;
        this.description = 'Remove 1 microbe from each card that can collect microbes. Add 1 animal to a card per influence';
        this.revealedDelegate = PartyName_1.PartyName.REDS;
        this.currentDelegate = PartyName_1.PartyName.GREENS;
    }
    SealockedHolmes.prototype.resolve = function (game, turmoil) {
        game.getPlayers().forEach(function (player) {
            var resourceCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
            resourceCards.forEach(function (card) {
                player.removeResourceFrom(card);
            });
            var amount = turmoil.getPlayerInfluence(player);
            if (amount > 0) {
                game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.ANIMAL, { count: amount }));
            }
        });
    };
    return SealockedHolmes;
}());
exports.SealockedHolmes = SealockedHolmes;
//# sourceMappingURL=SealockedHolmes.js.map